import React from 'react'
import { Container,Card , Button,Form} from 'react-bootstrap';
import AppNavbar from '../../../components/Navbar';
import { useState } from 'react';
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth';
import { Link } from 'react-router-dom';





const firebaseConfig = {
    apiKey: "AIzaSyBKWdYhj6i6NcBAiXmhAktyI_bAMwAJuOo",
    authDomain: "tripz-travel-bot.firebaseapp.com",
    projectId: "tripz-travel-bot",
    storageBucket: "tripz-travel-bot.appspot.com",
    messagingSenderId: "720844828187",
    appId: "1:720844828187:web:00adcaa6e56ca989d0d2be",
    measurementId: "G-5BCYRZXXNW"
  };
  
  firebase.initializeApp(firebaseConfig)


const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [resetEmailSent, setResetEmailSent] = useState(false);
  const [resetEmailError, setResetEmailError] = useState('');

  const handleResetPassword = (event) => {
    event.preventDefault();

    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(() => {
        setResetEmailSent(true);
        setResetEmailError('');
      })
      .catch((error) => {
        setResetEmailSent(false);
        const errorCode = error.code;
        let errorMessage = '';

        switch (errorCode) {
          case 'auth/invalid-email':
            errorMessage = 'Invalid email format.';
            break;
          case 'auth/user-not-found':
            errorMessage = 'User not found. Please provide registered email address.';
            break;
          
          default:
            errorMessage = 'An error occurred. Please try again later.';
        }

        setResetEmailError(errorMessage); // Set the error message in the state
       
      });
    
  };

  return (
    <div>
      <AppNavbar/>
      <Container fluid style={{background:'#F9F9F9'}} className='justify-content-center align-items-center text-align-center p-3 p-md-5'>
        
        <Card style={{background:'#fff', maxWidth:'45rem'}} className='p-3 p-md-5 m-auto my-4 border-0 '>
        <h3 className='text-center welcome'>Forgot Password</h3>
       
        {resetEmailSent ? (
        <p className='account mt-4 text-center'>Reset password email sent. Please check your email.</p>
      ) : (
        <Form className='p-2 px-md-5 py-3 ' >
           <p className='account '>Enter your registered email address and we’ll send the password reset instructions to your email</p> 
           <Form.Group className='mt-5 '>
           <Form.Label className='login-form-label'>Email Address</Form.Label>
          <Form.Control className=' py-2'
            type="email"
            placeholder="Enter valid email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
           {resetEmailError && <p className='text-danger'>{resetEmailError}</p>}
          </Form.Group>
            <div className='justify-content-center align-items-center text-center mt-5'>
        <Button className='login-btn border-0'onClick={handleResetPassword} >Reset Password</Button>
        </div>
         
        </Form>
      )}
           <div className='text-center mt-2'>
        <h5 className='account'>Remember your password? <span><Link to='/login' className='forgot-password'>Log In</Link></span></h5>
       
        </div>
            
        </Card>
       

     </Container>
    </div>
  )
}

export default ForgotPassword
